import routesConfig from '@mindfulchefuk/config/routesConfig'
import { useIsNewCustomer } from '@mindfulchefuk/features/Onboarding/hooks/useIsNewCustomer'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

export const useSignInRedirect = (isSignedIn: boolean) => {
  const router = useRouter()

  const { isNewCustomer, isFetched } = useIsNewCustomer()

  useEffect(() => {
    if (!isSignedIn || !isFetched) return

    if (isNewCustomer) {
      const isFromOnboarding =
        router.query.referrer === routesConfig.chooseRecipes.pathname

      const target = isFromOnboarding
        ? routesConfig.postLoginOnboardingShipping.pathname
        : routesConfig.home.pathname

      router.push(target)
    } else {
      const target = router.query.referrer
        ? decodeURIComponent(router.query.referrer as string)
        : routesConfig.upcoming.pathname

      router.push(target)
    }
  }, [isFetched, isNewCustomer, isSignedIn, router])
}
